import React from 'react';

interface BoardColumnProps {
  title: string;
  count: number;
  children: React.ReactNode;
  headerBgColor?: string;
  columnBgColor?: string;
  headerActions?: React.ReactNode;
  className?: string;
}

export const BoardColumn: React.FC<BoardColumnProps> = ({
  title,
  count,
  children,
  headerBgColor = 'bg-background',
  columnBgColor = 'bg-background',
  headerActions,
  className = ''
}) => {
  return (
    <div className={`flex flex-col flex-1 min-w-[280px] min-h-[200px] rounded-lg ${columnBgColor} overflow-y-auto h-full ${className}`}>
      {/* Column Header */}
      <div className={`${headerBgColor} px-3 py-2 rounded-md sticky top-0 z-8`}>
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <p className="font-sans font-semibold text-md text-text">
              {title}
            </p>
            {/* Header Actions - Inline with title */}
            {headerActions && (
              <div className="flex items-center gap-2">
                {headerActions}
              </div>
            )}
          </div>
          <span className="font-sans font-medium text-xs text-text-subtle bg-background px-2 py-0.5 rounded-full">
            {count}
          </span>
        </div>
      </div>
      
      {/* Column Content */}
      <div className="flex flex-col gap-2 p-3">
        {children}
      </div>
    </div>
  );
};

export default BoardColumn;

